import { ChangeEvent, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Input } from '@opendoor/bricks/core';

import { EmailQuestion } from 'src/lib/flow/FlowQuestion';
import { errorAnswer } from 'src/store/sellerFlow/actions';
import { changeAnswers } from 'src/store/sellerInput';

import QuestionLabel from '../common/QuestionLabel';
import { trackAnswerChange } from './trackAnswerChange';

type EmailInputProps = {
  question: EmailQuestion;
  value?: string;
};

const EmailInput: React.FC<EmailInputProps> = ({ question, value }) => {
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
  const { key, placeholder, label, helperText } = question;

  return (
    <Input
      analyticsName="reception-fe-question-email"
      id={key}
      type="email"
      delay={500}
      onChange={(
        _event: ChangeEvent<HTMLInputElement>,
        value: string | undefined,
        validFormat?: boolean,
      ) => {
        const answer = value ?? null;

        if (!validFormat) {
          const message = 'Hm, looks like that wasn’t a valid email.';
          setErrorMessage(message);
          dispatch(errorAnswer(key, true, message));
        } else if (errorMessage) {
          // clear our previous error message
          setErrorMessage(undefined);
          dispatch(errorAnswer(key, false));
        }

        dispatch(changeAnswers([{ key, answer }]));
        trackAnswerChange(key, value ?? undefined);
      }}
      onBlur={() => trackAnswerChange(key, value)}
      value={value}
      name={key}
      placeholder={placeholder}
      invalid={!!errorMessage}
      errorMessage={errorMessage}
      autoComplete="email"
      fontSize="s0"
      //unboundedWidth={unboundedWidth}
      //
      label={<QuestionLabel title={label} tooltip={helperText} unboundedWidth />}
    />
  );
};

export default EmailInput;
